import React, { useState } from "react";
import { string, func, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import "./password-field.m.css";

const PasswordField = ({ error, label, onTextChange, publisherAttributes, ...props }) => {
  const [isPassoword, setIsPassword] = useState(true);
  const [password, setPassword] = useState("");

  const onChange = (e) => {
    setPassword(e.target.value);

    if (onTextChange) {
      onTextChange(e.target.value || null);
    }
  };

  const showHide = () => setIsPassword(!isPassoword);

  return (
    <div styleName={`wrapper ${publisherAttributes.lang}-wrapper`} className="wrapper-password">
      {label && (
        <label styleName="label" className="label">
          {label}
        </label>
      )}
      <div styleName="input-wrapper" className="password-input-wrapper">
        <input
          type={isPassoword ? "password" : "text"}
          value={password}
          styleName={error ? "password password-error" : "password"}
          className="password"
          onChange={onChange}
          {...props}
        />
        <span styleName="password_show" className="show-password" onClick={showHide}>
          {isPassoword ? "Show" : "Hide"}
        </span>
      </div>
      {error && <span styleName="error">{error}</span>}
    </div>
  );
};

PasswordField.propTypes = {
  error: string,
  label: string,
  onTextChange: func,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps)(PasswordField);
